export default "/images/vendor/flag-icon-css/flags/4x3/sz.svg?bec727f47598d1d82a171ee1387ed8ef";